import AdminLayerBlueprint from "components/blueprints/AdminLayerBlueprint";
import React from "react";
import AdminSupportTable from "./AdminSupportTable";
import AdminSupportTableHeader from "./AdminSupportTableHeader";

function AdminSupportPage() {
  return (
    <section className="bg-gray-100" style={{ minHeight: "calc(100vh - 60px)" }}>
      <div className="container mx-auto">
        <div className="bg-white pt-2 pb-6 shadow-md blur-2 text-opacity-15 spread-0 mb-[30px]">
          <AdminSupportTableHeader />
          <AdminSupportTable />
        </div>
      </div>
    </section>
  );
}

export default AdminLayerBlueprint(AdminSupportPage);
